import gql from 'graphql-tag';
import Image from 'next/image';
import { useRouter } from 'next/router';
import React from 'react';

import TopImg from '../../public/images/home/top.png';

import ProjectCard, { ProjectCardProject } from '@src/components/ProjectCard';
import SEOMeta from '@src/components/SEOMeta';
import { useHomePageProjectsForHomeQuery } from '@src/generated/graphql';
import { handleApolloError } from '@src/lib/apolloClient';

gql`
    query homePageProjectsForHome {
        ${ProjectCardProject}
        projectsForHome {
            ...ProjectCardProject
        }
    }
`;

export default function HomePage() {
  const router = useRouter();
  const { data, error } = useHomePageProjectsForHomeQuery({
    fetchPolicy: 'cache-and-network',
  });

  if (error) {
    handleApolloError(error, router);
  }

  return (
    <div className="mx-auto mb-8">
      <SEOMeta
        title="興味があるプロジェクトを探して参加してみよう！　『イチイン』"
        excludeSiteTitle
        description="このページでは、イチインの数あるプロジェクトを探すことができます。あなたにとって「興味がある！」「参加したい！」と思えるプロジェクトを見つけてみてください。"
        img={{ srcPath: TopImg.src }}
      />
      <div className="overflow-hidden relative max-h-[400px]">
        <div className="lg:mt-[-250px] xl:mt-[-350px]" />
        <Image
          src={TopImg}
          alt="カバー画像"
          height={910}
          width={750}
          loading="eager"
          layout="responsive"
          objectFit="contain"
          objectPosition="center"
        />
      </div>
      <div className="mx-auto max-w-[1000px]">
        <h2 className="m-6 mt-12 text-2xl md:text-3xl font-bold">
          新着プロジェクト
        </h2>
        <div className="flex flex-col items-center sm:m-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 sm:gap-4 px-6 w-full">
            {data?.projectsForHome.map((project) => (
              <ProjectCard key={project.id} project={project} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
